<div class="phone-country-select">
  <button
    type="button"
    class="form-control phone-country-select__toggle"
    #toggleButton
    [id]="id"
    [disabled]="disabled"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    [attr.aria-controls]="isOpen ? listboxId : null"
    [attr.aria-label]="toggleLabel"
    (click)="toggle()"
    (keydown)="onKeydown($event)"
  >
    <span class="fi phone-country-select__flag" [ngClass]="'fi-' + selectedCountry.iso2.toLowerCase()"></span>
    <span class="phone-country-select__dial">+{{ selectedCountry.dialCode }}</span>
  </button>

  <div class="phone-country-select__panel" *ngIf="isOpen">
    <input
      #searchInput
      type="text"
      class="form-control phone-country-select__search"
      [(ngModel)]="search"
      (ngModelChange)="onSearchChange()"
      (keydown)="onKeydown($event)"
      placeholder="Buscar país"
      autocomplete="off"
      role="combobox"
      aria-label="Buscar país"
      aria-expanded="true"
      [attr.aria-controls]="listboxId"
      [attr.aria-activedescendant]="activeOptionId"
    />
    <ul class="phone-country-select__list" role="listbox" [id]="listboxId">
      <li
        *ngFor="let c of filteredCountries; let i = index"
        class="phone-country-select__item"
        [id]="optionId(c)"
        [class.selected]="c.iso2 === country"
        [class.active]="i === activeIndex"
        [attr.aria-selected]="c.iso2 === country"
        role="option"
        (click)="select(c)"
      >
        <span class="fi phone-country-select__flag" [ngClass]="'fi-' + c.iso2.toLowerCase()"></span>
        <span class="phone-country-select__dial">+{{ c.dialCode }}</span>
        <span class="phone-country-select__name">{{ c.name }}</span>
      </li>
      <li *ngIf="!filteredCountries.length" class="phone-country-select__empty">Nenhum país encontrado</li>
    </ul>
  </div>
</div>
